/*
 * @Author: Tahiti
 * @Date: 2025-10-28 18:00:00
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-17 15:46:26
 * @Description: About Us 页面多语言配置
 * @FilePath: /weryai-web/locales/modules/img_bg_remove.ts
 */
export default {
    zh: {
        pageTitle: 'AI 图片背景移除',
        title: '立即去除图像的背景',
        short_title: '精准识别，一键分离主体与背景',
        description:
            '我们的 AI 背景去除器可一键清除背景场景与杂物，通过精准主体识别实现完美输出。适用于专业人像与电商产品图，并支持批量处理以快速高效操作多张图片。',
        keywords:
            'AI 图片背景移除, 图片背景移除, 背景移除, 背景去除, 背景移除工具, 背景去除工具',
        feature_title1: `提升电商产品吸引力`,
        feature_desc1: `通过移除干扰性的背景，创建干净专业的商品图以吸引注意并增强客户信任，从而提升销售转化率。`,
        feature_title2: `创建精致专业人像`,
        feature_desc2: `从照片中移除背景，立即生成适用于简历、作品集及专业场景的优雅人像照片。`,
        feature_title3: `打造吸睛社交媒体内容`,
        feature_desc3: `通过分离主体，简化帖文与广告创作，实现与自定义背景或创意设计的无缝融合，从而提高与观众的互动率。`,
        feature_title4: `节省设计项目时间`,
        feature_desc4: `轻松移除背景以专注创意构思，加速设计流程并在拼贴、海报或营销物料中实现高质量成果。`,
        use_step1: '点击上传图片',
        use_step2: '等待工具识别并去除图片背景',
        use_step3: '数秒内即可下载无背景的高质量图片',
        faq: [
            {
                question: `什么是 AI 背景去除器？`,
                answer: `AI 背景去除器可用于即时清除照片及其他图片的背景。它能通过 AI 算法区分背景与主体，清除背景而不破坏主体。`,
            },
            {
                question: `为什么要使用我们的背景去除器？`,
                answer: `微鲤AI 是当前最强大的图片背景移除工具。其采用领先的AI技术精确识别背景与主体，以精细细节彻底清除背景，便于您为主体添加任何新的背景。`,
            },
            {
                question: `最好的 AI 背景去除器是？`,
                answer: `微鲤AI 凭借领先技术成为最佳选择。它能稳定处理不同尺寸与质量图片的背主分离，始终高效完成背景移除。
`,
            },
            {
                question: `如何用 AI 去除背景？`,
                answer: `使用 微鲤AI 背景移除工具只需访问指定页面，上传需处理的图片。AI 将自动识别背景并在数秒内完成清除。`,
            },
            {
                question: `这个 AI 背景去除器可以免费试用吗？`,
                answer: `可以，微鲤AI 图片背景移除工具提供免费试用积分。与其他 AI 图片编辑工具一样，用户无需付费即可直接试用。`,
            },
            {
                question: `我们的 AI 背景去除器支持哪些图像格式？`,
                answer: `此背景去除工具支持所有主流格式，包括 JPEG、PNG 等。上传图片即可移除背景。`,
            },
            {
                question: `我们的免费背景去除器处理速度有多快？`,
                answer: `速度极快，通常仅需数秒即可完成。具体速度可能因网络环境等因素有所差异。`,
            },
            {
                question: `上传的图片会保证私密与安全吗？`,
                answer: `绝对安全。我们严格保障隐私与安全，所有用户数据均加密存储于安全服务器，其他用户无法查看或访问您的数据或文件。`,
            },
            {
                question: `我们的 AI 背景去除器能处理旧图像吗？`,
                answer: `可以，它适用于任何图像，无论其年代、大小或质量如何。不过，当主体和背景之间有明显区别时，它的移除效果最好。`,
            },
        ],
        uploadTip:
            '支持 JPEG、PNG、WEBP等格式，大小不超过 15MB, 分辨率不超过 4096x4096 像素',
    },
    en: {
        pageTitle: 'AI Image Background Remover',
        title: 'Remove Image Background Instantly',
        short_title:
            'Precise detection, one-click subject/background separation',
        description:
            'Our AI background remover clears scenes and clutter in one click with precise subject detection for clean, professional results. Perfect for portraits and e-commerce product photos, and supports batch processing for fast editing of multiple images.',
        keywords:
            'AI image background remover, remove image background, background removal, remove background, background remover tool, background removal tool',
        feature_title1: 'Boost E-commerce Product Appeal',
        feature_desc1:
            'Remove distracting backgrounds to create clean, professional product photos that grab attention, build trust, and improve conversions.',
        feature_title2: 'Create Polished Professional Portraits',
        feature_desc2:
            'Remove the background from a photo to instantly generate an elegant portrait suitable for resumes, portfolios, and professional settings.',
        feature_title3: 'Make Eye-catching Social Media Content',
        feature_desc3:
            'Isolate the subject to simplify post and ad creation, blending seamlessly with custom backgrounds or creative designs to increase engagement.',
        feature_title4: 'Save Time on Design Projects',
        feature_desc4:
            'Remove backgrounds effortlessly to focus on ideas, speed up workflows, and deliver high-quality results for collages, posters, and marketing assets.',
        use_step1: 'Click to upload an image',
        use_step2: 'Wait for the tool to detect and remove the background',
        use_step3:
            'Download a high-quality image with a transparent background in seconds',
        faq: [
            {
                question: 'What is an AI background remover?',
                answer: 'An AI background remover instantly clears the background from photos and other images. It uses AI to distinguish the subject from the background, removing the background without damaging the subject.',
            },
            {
                question: 'Why use our background remover?',
                answer: '微鲤AI is one of the most powerful image background removal tools available. With advanced AI, it precisely separates subjects from backgrounds and removes backgrounds with fine detail—so you can add any new background you want.',
            },
            {
                question: 'What is the best AI background remover?',
                answer: '微鲤AI is a top choice thanks to its leading technology. It reliably separates subjects from backgrounds across different sizes and image qualities, delivering fast and consistent results.',
            },
            {
                question: 'How do I remove a background with AI?',
                answer: 'Simply open the 微鲤AI background remover page and upload the image you want to edit. AI will automatically detect the background and remove it in seconds.',
            },
            {
                question: 'Can I try this AI background remover for free?',
                answer: 'Yes. 微鲤AI provides free trial credits, so you can test the background remover without paying—just like our other AI image tools.',
            },
            {
                question: 'Which image formats are supported?',
                answer: 'This background remover supports popular formats such as JPEG and PNG. Upload your image and remove the background instantly.',
            },
            {
                question: 'How fast is the free background remover?',
                answer: 'It is very fast and usually finishes in just a few seconds. Speed may vary slightly depending on network conditions.',
            },
            {
                question: 'Are my uploaded images private and secure?',
                answer: 'Yes. We take privacy and security seriously. All user data is encrypted and stored on secure servers, and other users cannot view or access your files.',
            },
            {
                question: 'Can it handle old images?',
                answer: 'Yes. It works with any image, regardless of age, size, or quality. For best results, make sure there is clear contrast between the subject and the background.',
            },
        ],
        uploadTip:
            'Supports JPEG, PNG, WEBP and more. Max size 15MB. Max resolution 4096×4096 pixels.',
    },
    ja: {
        pageTitle: 'AI 画像背景除去',
        title: '画像の背景を今すぐ削除',
        short_title: '高精度認識で、ワンクリックで被写体と背景を分離',
        description:
            '当社のAI背景除去ツールは、ワンクリックで背景のシーンや不要物を消去し、正確な被写体認識で自然な仕上がりを実現します。プロのポートレートやECの商品画像に最適で、複数枚の一括処理にも対応します。',
        keywords:
            'AI 背景除去, 画像 背景除去, 背景削除, 背景を消す, 背景除去ツール, 背景除去 AI',
        feature_title1: 'EC商品画像の魅力をアップ',
        feature_desc1:
            '邪魔な背景を取り除き、清潔感のあるプロ仕様の商品画像を作成。注目を集め、信頼を高め、購入率向上につながります。',
        feature_title2: '洗練されたプロフィール写真に',
        feature_desc2:
            '写真の背景を削除し、履歴書・ポートフォリオ・ビジネス用途に使える上品な人物写真をすぐに作れます。',
        feature_title3: 'SNSで目を引くコンテンツ作り',
        feature_desc3:
            '被写体を切り抜いて投稿や広告制作を簡単に。任意の背景やデザインと自然に合成でき、エンゲージメント向上に役立ちます。',
        feature_title4: 'デザイン作業の時間を節約',
        feature_desc4:
            '背景除去を手軽に行い、アイデアに集中。コラージュ、ポスター、販促素材などで高品質な成果をスピーディに作れます。',
        use_step1: 'クリックして画像をアップロード',
        use_step2: 'ツールが認識して背景を除去するのを待つ',
        use_step3: '数秒で高画質な透過画像をダウンロード',
        faq: [
            {
                question: 'AI背景除去とは？',
                answer: 'AI背景除去は、写真などの背景を即座に削除できる機能です。AIが背景と被写体を判別し、被写体を損なわずに背景だけを取り除きます。',
            },
            {
                question: 'なぜ当社の背景除去を使うべきですか？',
                answer: 'WeryAIは強力な画像背景除去ツールです。先進的なAIで背景と被写体を高精度に分離し、細部まできれいに背景を除去できるため、被写体に好きな背景を追加できます。',
            },
            {
                question: '最適なAI背景除去ツールは？',
                answer: 'WeryAIは先進技術により有力な選択肢です。サイズや画質が異なる画像でも安定して被写体と背景を分離し、常に高速で背景除去を行います。',
            },
            {
                question: 'AIで背景を削除する方法は？',
                answer: 'WeryAIの背景除去ページにアクセスして画像をアップロードするだけです。AIが自動で背景を認識し、数秒で削除します。',
            },
            {
                question: '無料で試せますか？',
                answer: 'はい。WeryAIは無料トライアル用のクレジットを提供しており、料金を支払わずにすぐ試せます。',
            },
            {
                question: '対応している画像形式は？',
                answer: 'JPEG、PNGなど主要な形式に対応しています。画像をアップロードするだけで背景を削除できます。',
            },
            {
                question: '処理速度はどれくらいですか？',
                answer: '非常に高速で、通常は数秒で完了します。ネットワーク環境などにより多少前後します。',
            },
            {
                question: 'アップロードした画像は安全ですか？',
                answer: 'はい。プライバシーとセキュリティを最優先にしており、ユーザーデータは暗号化して安全なサーバーに保存されます。他のユーザーが閲覧・アクセスすることはできません。',
            },
            {
                question: '古い写真でも使えますか？',
                answer: 'はい。年代・サイズ・画質を問わず利用できます。ただし、被写体と背景の差がはっきりしているほど、より良い結果が得られます。',
            },
        ],
        uploadTip:
            'JPEG、PNG、WEBPなどに対応。最大15MB、最大解像度4096×4096ピクセル。',
    },
    ko: {
        pageTitle: 'AI 이미지 배경 제거',
        title: '이미지 배경을 즉시 제거하세요',
        short_title: '정확한 인식, 한 번의 클릭으로 피사체와 배경 분리',
        description:
            '저희 AI 배경 제거기는 한 번의 클릭으로 배경 장면과 불필요한 요소를 지우고, 정확한 피사체 인식으로 깔끔한 결과를 제공합니다. 전문 인물 사진과 이커머스 상품 이미지에 적합하며, 여러 장을 빠르게 처리할 수 있는 일괄 처리도 지원합니다.',
        keywords:
            'AI 이미지 배경 제거, 이미지 배경 제거, 배경 제거, 배경 지우기, 배경 제거 도구, AI 사진 편집',
        feature_title1: '이커머스 상품 매력 향상',
        feature_desc1:
            '방해되는 배경을 제거해 깔끔하고 전문적인 상품 이미지를 만들고, 주목도와 신뢰를 높여 전환율 향상에 도움을 줍니다.',
        feature_title2: '세련된 프로필 사진 만들기',
        feature_desc2:
            '사진에서 배경을 제거해 이력서, 포트폴리오, 업무 환경에 어울리는 우아한 인물 사진을 즉시 생성할 수 있습니다.',
        feature_title3: '눈길을 끄는 SNS 콘텐츠 제작',
        feature_desc3:
            '피사체를 분리해 게시물·광고 제작을 간단하게 만들고, 원하는 배경이나 크리에이티브 디자인과 자연스럽게 합성해 참여도를 높일 수 있습니다.',
        feature_title4: '디자인 작업 시간 절약',
        feature_desc4:
            '배경 제거를 손쉽게 수행해 아이디어에 집중하고 작업 흐름을 가속화하며, 콜라주·포스터·마케팅 소재에서 고품질 결과물을 빠르게 완성할 수 있습니다.',
        use_step1: '클릭하여 이미지 업로드',
        use_step2: '도구가 인식해 배경을 제거할 때까지 기다리기',
        use_step3: '몇 초 안에 배경 없는 고화질 이미지를 다운로드',
        faq: [
            {
                question: 'AI 배경 제거기란 무엇인가요?',
                answer: 'AI 배경 제거기는 사진 및 기타 이미지의 배경을 즉시 지울 수 있는 도구입니다. AI 알고리즘이 배경과 피사체를 구분해 피사체를 손상시키지 않고 배경만 제거합니다.',
            },
            {
                question: '왜 저희 배경 제거기를 사용해야 하나요?',
                answer: 'WeryAI는 강력한 이미지 배경 제거 도구입니다. 선도적인 AI 기술로 배경과 피사체를 정밀하게 인식하고, 디테일까지 깔끔하게 배경을 제거해 원하는 어떤 배경이든 쉽게 추가할 수 있습니다.',
            },
            {
                question: '가장 좋은 AI 배경 제거기는 무엇인가요?',
                answer: 'WeryAI는 선도적인 기술로 훌륭한 선택입니다. 다양한 크기와 품질의 이미지에서도 안정적으로 피사체와 배경을 분리해 빠르고 일관된 결과를 제공합니다.',
            },
            {
                question: 'AI로 배경을 어떻게 제거하나요?',
                answer: '微鲤AI 배경 제거 페이지에 접속해 이미지를 업로드하기만 하면 됩니다. AI가 자동으로 배경을 인식하고 몇 초 만에 제거합니다.',
            },
            {
                question: '무료로 체험할 수 있나요?',
                answer: '네. WeryAI는 무료 체험 크레딧을 제공하므로, 별도의 결제 없이 바로 배경 제거 기능을 테스트할 수 있습니다.',
            },
            {
                question: '어떤 이미지 형식을 지원하나요?',
                answer: 'JPEG, PNG 등 주요 형식을 지원합니다. 이미지를 업로드하면 즉시 배경을 제거할 수 있습니다.',
            },
            {
                question: '처리 속도는 얼마나 빠른가요?',
                answer: '매우 빠르며 보통 몇 초 내에 완료됩니다. 네트워크 환경 등에 따라 속도는 약간 달라질 수 있습니다.',
            },
            {
                question: '업로드한 이미지는 안전한가요?',
                answer: '네. 개인정보와 보안을 엄격히 보호하며, 모든 사용자 데이터는 암호화되어 안전한 서버에 저장됩니다. 다른 사용자가 파일을 보거나 접근할 수 없습니다.',
            },
            {
                question: '오래된 이미지도 처리할 수 있나요?',
                answer: '네. 이미지의 연식, 크기, 품질과 관계없이 사용할 수 있습니다. 다만 피사체와 배경의 대비가 뚜렷할수록 제거 결과가 더 좋습니다.',
            },
        ],
        uploadTip:
            'JPEG, PNG, WEBP 등 지원. 최대 15MB, 최대 해상도 4096×4096 픽셀.',
    },
    es: {
        pageTitle: 'Eliminación de fondo de imagen con IA',
        title: 'Elimina el fondo de tus imágenes al instante',
        short_title: 'Detección precisa, separa sujeto y fondo con un clic',
        description:
            'Nuestro eliminador de fondo con IA borra escenas y elementos no deseados con un solo clic gracias a una detección precisa del sujeto. Ideal para retratos y fotos de producto para e-commerce, y con soporte para procesar varias imágenes en lote de forma rápida.',
        keywords:
            'eliminador de fondo con IA, quitar fondo de imagen, eliminación de fondo, quitar fondo, herramienta para quitar fondo, remover fondo',
        feature_title1: 'Mejora el atractivo de productos en e-commerce',
        feature_desc1:
            'Elimina fondos distractores para crear fotos de producto limpias y profesionales que atraen miradas, generan confianza y mejoran la conversión.',
        feature_title2: 'Crea retratos profesionales y pulidos',
        feature_desc2:
            'Quita el fondo de una foto y genera al instante un retrato elegante, ideal para CV, portafolios y contextos profesionales.',
        feature_title3: 'Crea contenido llamativo para redes sociales',
        feature_desc3:
            'Separa el sujeto para simplificar la creación de publicaciones y anuncios, integrándolo sin esfuerzo con fondos personalizados o diseños creativos para aumentar la interacción.',
        feature_title4: 'Ahorra tiempo en proyectos de diseño',
        feature_desc4:
            'Elimina fondos fácilmente para enfocarte en la creatividad, acelerar el flujo de trabajo y lograr resultados de alta calidad en collages, pósters y materiales de marketing.',
        use_step1: 'Haz clic para subir una imagen',
        use_step2: 'Espera a que la herramienta detecte y elimine el fondo',
        use_step3: 'Descarga en segundos una imagen de alta calidad sin fondo',
        faq: [
            {
                question: '¿Qué es un eliminador de fondo con IA?',
                answer: 'Un eliminador de fondo con IA permite quitar el fondo de fotos y otras imágenes al instante. La IA distingue el sujeto del fondo y elimina el fondo sin dañar el sujeto.',
            },
            {
                question: '¿Por qué usar nuestro eliminador de fondo?',
                answer: '微鲤AI es una de las herramientas más potentes para quitar fondos. Con IA avanzada, identifica con precisión el sujeto y el fondo, elimina el fondo con gran detalle y te permite añadir cualquier nuevo fondo al sujeto.',
            },
            {
                question: '¿Cuál es el mejor eliminador de fondo con IA?',
                answer: '微鲤AI es una excelente opción gracias a su tecnología líder. Separa sujeto y fondo de forma estable en imágenes de distintos tamaños y calidades, con resultados rápidos y consistentes.',
            },
            {
                question: '¿Cómo quitar el fondo con IA?',
                answer: 'Solo entra en la página del eliminador de fondo de 微鲤AI y sube la imagen que quieres editar. La IA detectará el fondo y lo eliminará en segundos.',
            },
            {
                question: '¿Se puede probar gratis?',
                answer: 'Sí. 微鲤AI ofrece créditos de prueba gratuitos para que puedas probar la herramienta sin pagar, igual que con nuestras otras herramientas de edición con IA.',
            },
            {
                question: '¿Qué formatos de imagen son compatibles?',
                answer: 'La herramienta admite formatos populares como JPEG y PNG. Sube tu imagen y elimina el fondo al instante.',
            },
            {
                question: '¿Qué tan rápido es el eliminador de fondo gratuito?',
                answer: 'Es muy rápido y normalmente se completa en solo unos segundos. La velocidad puede variar ligeramente según la red.',
            },
            {
                question: '¿Mis imágenes subidas son privadas y seguras?',
                answer: 'Sí. Protegemos la privacidad y la seguridad: los datos se almacenan cifrados en servidores seguros y otros usuarios no pueden ver ni acceder a tus archivos.',
            },
            {
                question: '¿Puede manejar imágenes antiguas?',
                answer: 'Sí. Funciona con cualquier imagen, sin importar su antigüedad, tamaño o calidad. Para mejores resultados, debe haber una clara diferencia entre el sujeto y el fondo.',
            },
        ],
        uploadTip:
            'Compatible con JPEG, PNG, WEBP y más. Tamaño máximo 15MB. Resolución máxima 4096×4096 píxeles.',
    },
    fr: {
        pageTitle: "Suppression de fond d'image avec IA",
        title: 'Supprimez le fond de vos images instantanément',
        short_title:
            'Détection précise, séparation du sujet et du fond en un clic',
        description:
            'Notre outil IA de suppression d’arrière-plan efface en un clic les scènes et éléments indésirables grâce à une détection précise du sujet. Idéal pour les portraits et les photos produit e-commerce, avec prise en charge du traitement par lots pour aller plus vite.',
        keywords:
            "suppression d'arrière-plan IA, supprimer fond image, suppression de fond, enlever le fond, outil suppression de fond, détourage IA",
        feature_title1: "Augmentez l'attrait des produits e-commerce",
        feature_desc1:
            'Supprimez les fonds distrayants pour créer des visuels produit propres et professionnels qui attirent l’attention, renforcent la confiance et améliorent la conversion.',
        feature_title2: 'Créez des portraits professionnels soignés',
        feature_desc2:
            'Retirez le fond d’une photo et obtenez instantanément un portrait élégant, idéal pour CV, portfolio et usages professionnels.',
        feature_title3: 'Créez du contenu accrocheur pour les réseaux sociaux',
        feature_desc3:
            'Isolez le sujet pour simplifier la création de posts et de publicités, et intégrez-le facilement à un fond personnalisé ou à un design créatif pour augmenter l’engagement.',
        feature_title4: 'Gagnez du temps sur vos projets de design',
        feature_desc4:
            'Supprimez le fond en toute simplicité pour vous concentrer sur la création, accélérer votre workflow et produire des résultats de qualité pour collages, affiches et supports marketing.',
        use_step1: 'Cliquez pour importer une image',
        use_step2: "Attendez que l'outil détecte et supprime le fond",
        use_step3:
            'Téléchargez en quelques secondes une image de haute qualité sans fond',
        faq: [
            {
                question: "Qu'est-ce qu'un outil IA de suppression de fond ?",
                answer: 'Un outil IA de suppression de fond permet d’effacer instantanément l’arrière-plan de photos et d’images. Il utilise l’IA pour distinguer le sujet du fond et retirer le fond sans endommager le sujet.',
            },
            {
                question:
                    'Pourquoi utiliser notre outil de suppression de fond ?',
                answer: '微鲤AI est l’un des outils les plus puissants pour supprimer les arrière-plans. Grâce à une IA avancée, il sépare précisément le sujet du fond et supprime le fond avec un grand niveau de détail, afin que vous puissiez ajouter n’importe quel nouveau fond.',
            },
            {
                question:
                    'Quel est le meilleur outil IA de suppression de fond ?',
                answer: '微鲤AI est un excellent choix grâce à sa technologie de pointe. Il sépare de façon fiable le sujet du fond sur des images de tailles et de qualités variées, avec des résultats rapides et constants.',
            },
            {
                question: 'Comment supprimer un fond avec l’IA ?',
                answer: 'Il suffit d’ouvrir la page de suppression de fond 微鲤AI et d’importer l’image à traiter. L’IA détecte automatiquement le fond et le supprime en quelques secondes.',
            },
            {
                question: "Puis-je l'essayer gratuitement ?",
                answer: 'Oui. 微鲤AI propose des crédits d’essai gratuits, vous permettant de tester l’outil sans payer, comme nos autres outils d’édition d’images IA.',
            },
            {
                question: 'Quels formats d’image sont pris en charge ?',
                answer: 'L’outil prend en charge les formats courants comme JPEG et PNG. Importez votre image et supprimez le fond instantanément.',
            },
            {
                question: "Quelle est la vitesse de l'outil gratuit ?",
                answer: 'Il est très rapide et ne prend généralement que quelques secondes. La vitesse peut varier légèrement selon le réseau.',
            },
            {
                question:
                    'Mes images importées sont-elles privées et sécurisées ?',
                answer: 'Oui. Nous protégeons strictement la confidentialité et la sécurité : toutes les données sont chiffrées et stockées sur des serveurs sécurisés, et les autres utilisateurs ne peuvent ni voir ni accéder à vos fichiers.',
            },
            {
                question: "Peut-il traiter d'anciennes images ?",
                answer: 'Oui. Il fonctionne avec toutes les images, quel que soit leur âge, leur taille ou leur qualité. Pour de meilleurs résultats, il est préférable qu’il y ait une différence nette entre le sujet et l’arrière-plan.',
            },
        ],
        uploadTip:
            'Prend en charge JPEG, PNG, WEBP et plus. Taille max 15MB. Résolution max 4096×4096 px.',
    },
    de: {
        pageTitle: 'AI Bildhintergrund entfernen',
        title: 'Entferne den Bildhintergrund sofort',
        short_title:
            'Präzise Erkennung – Motiv und Hintergrund mit einem Klick trennen',
        description:
            'Unser KI-Hintergrundentferner löscht Szenen und störende Elemente mit einem Klick – dank präziser Motiverkennung. Ideal für professionelle Porträts und E-Commerce-Produktfotos und mit Batch-Verarbeitung für die schnelle Bearbeitung mehrerer Bilder.',
        keywords:
            'KI Hintergrund entfernen, Bildhintergrund entfernen, Hintergrund entfernen, Hintergrund löschen, Hintergrundentferner, Hintergrund entfernen Tool',
        feature_title1: 'Mehr Wirkung für E-Commerce-Produktfotos',
        feature_desc1:
            'Entferne ablenkende Hintergründe und erstelle saubere, professionelle Produktbilder, die Aufmerksamkeit wecken, Vertrauen stärken und die Conversion steigern.',
        feature_title2: 'Professionelle Porträts mit Stil',
        feature_desc2:
            'Entferne den Hintergrund eines Fotos und erhalte sofort ein elegantes Porträt – perfekt für Lebenslauf, Portfolio und professionelle Anwendungen.',
        feature_title3: 'Auffälliger Content für Social Media',
        feature_desc3:
            'Isoliere das Motiv und vereinfache die Erstellung von Posts und Anzeigen. Lässt sich nahtlos mit eigenen Hintergründen oder kreativen Designs kombinieren und erhöht die Interaktion.',
        feature_title4: 'Zeit sparen bei Designprojekten',
        feature_desc4:
            'Entferne Hintergründe mühelos, fokussiere dich auf Ideen, beschleunige Workflows und erziele hochwertige Ergebnisse für Collagen, Poster und Marketingmaterial.',
        use_step1: 'Klicke, um ein Bild hochzuladen',
        use_step2: 'Warte, bis das Tool den Hintergrund erkennt und entfernt',
        use_step3:
            'Lade in wenigen Sekunden ein hochwertiges Bild ohne Hintergrund herunter',
        faq: [
            {
                question: 'Was ist ein KI-Hintergrundentferner?',
                answer: 'Ein KI-Hintergrundentferner entfernt den Hintergrund von Fotos und anderen Bildern in Sekunden. Die KI unterscheidet Motiv und Hintergrund und entfernt den Hintergrund, ohne das Motiv zu beschädigen.',
            },
            {
                question: 'Warum unseren Hintergrundentferner nutzen?',
                answer: '微鲤AI ist eines der leistungsstärksten Tools zur Hintergrundentfernung. Mit fortschrittlicher KI trennt es Motiv und Hintergrund präzise und entfernt den Hintergrund bis ins Detail – damit du jedes beliebige neue Hintergrundbild hinzufügen kannst.',
            },
            {
                question: 'Welches ist der beste KI-Hintergrundentferner?',
                answer: '微鲤AI ist dank führender Technologie eine Top-Wahl. Es trennt Motiv und Hintergrund zuverlässig bei unterschiedlichen Bildgrößen und -qualitäten und liefert schnelle, konsistente Ergebnisse.',
            },
            {
                question: 'Wie entferne ich den Hintergrund mit KI?',
                answer: 'Öffne einfach die 微鲤AI-Seite zur Hintergrundentfernung und lade dein Bild hoch. Die KI erkennt den Hintergrund automatisch und entfernt ihn in wenigen Sekunden.',
            },
            {
                question: 'Kann ich es kostenlos testen?',
                answer: 'Ja. 微鲤AI bietet kostenlose Testguthaben, sodass du das Tool ohne Zahlung ausprobieren kannst – wie bei unseren anderen KI-Bildtools.',
            },
            {
                question: 'Welche Bildformate werden unterstützt?',
                answer: 'Das Tool unterstützt gängige Formate wie JPEG und PNG. Lade dein Bild hoch und entferne den Hintergrund sofort.',
            },
            {
                question: 'Wie schnell ist das kostenlose Tool?',
                answer: 'Sehr schnell – meist nur wenige Sekunden. Die Geschwindigkeit kann je nach Netzwerk leicht variieren.',
            },
            {
                question: 'Sind meine hochgeladenen Bilder privat und sicher?',
                answer: 'Ja. Wir schützen Privatsphäre und Sicherheit strikt: Alle Daten werden verschlüsselt und auf sicheren Servern gespeichert. Andere Nutzer können deine Dateien weder sehen noch darauf zugreifen.',
            },
            {
                question: 'Funktioniert es auch bei alten Bildern?',
                answer: 'Ja. Es funktioniert mit jedem Bild – unabhängig von Alter, Größe oder Qualität. Am besten gelingt es, wenn Motiv und Hintergrund klar unterscheidbar sind.',
            },
        ],
        uploadTip:
            'Unterstützt JPEG, PNG, WEBP und mehr. Max. 15MB, max. Auflösung 4096×4096 Pixel.',
    },
    ru: {
        pageTitle: 'Удаление фона изображения с помощью ИИ',
        title: 'Удалите фон изображения мгновенно',
        short_title:
            'Точное распознавание — отделите объект от фона в один клик',
        description:
            'Наш ИИ‑инструмент для удаления фона удаляет сцену и лишние детали в один клик благодаря точному распознаванию объекта. Подходит для профессиональных портретов и товарных фото для e‑commerce, а также поддерживает пакетную обработку для быстрого редактирования нескольких изображений.',
        keywords:
            'удаление фона ИИ, убрать фон с фото, удаление фона, вырезать фон, инструмент удаления фона, фон удалить',
        feature_title1: 'Повышайте привлекательность товаров в e‑commerce',
        feature_desc1:
            'Убирайте отвлекающий фон, чтобы получать чистые и профессиональные товарные фото, привлекать внимание, повышать доверие и конверсию.',
        feature_title2: 'Создавайте аккуратные профессиональные портреты',
        feature_desc2:
            'Удалите фон с фотографии и сразу получите элегантный портрет для резюме, портфолио и профессиональных задач.',
        feature_title3: 'Делайте контент для соцсетей более заметным',
        feature_desc3:
            'Отделите объект, упростите создание постов и рекламы и легко комбинируйте с любым фоном или дизайном, чтобы повысить вовлечённость.',
        feature_title4: 'Экономьте время на дизайн‑проектах',
        feature_desc4:
            'Удаляйте фон без лишних усилий, сосредоточьтесь на идеях, ускорьте рабочий процесс и получайте качественные результаты для коллажей, постеров и маркетинговых материалов.',
        use_step1: 'Нажмите, чтобы загрузить изображение',
        use_step2: 'Подождите, пока инструмент распознает и удалит фон',
        use_step3:
            'Скачайте качественное изображение без фона за несколько секунд',
        faq: [
            {
                question: 'Что такое ИИ‑удаление фона?',
                answer: 'ИИ‑удаление фона позволяет мгновенно удалить фон с фотографий и других изображений. Алгоритмы ИИ различают объект и фон и удаляют фон, не повреждая объект.',
            },
            {
                question: 'Почему стоит выбрать наш инструмент?',
                answer: '微鲤AI — один из самых мощных инструментов для удаления фона. Благодаря передовым технологиям ИИ он точно отделяет объект от фона и удаляет фон с высокой детализацией, чтобы вы могли добавить любой новый фон.',
            },
            {
                question: 'Какой ИИ‑инструмент лучший для удаления фона?',
                answer: '微鲤AI — отличный выбор благодаря ведущим технологиям. Он стабильно отделяет объект от фона на изображениях разных размеров и качества, обеспечивая быстрый и предсказуемый результат.',
            },
            {
                question: 'Как удалить фон с помощью ИИ?',
                answer: 'Откройте страницу удаления фона 微鲤AI и загрузите нужное изображение. ИИ автоматически распознает фон и удалит его за несколько секунд.',
            },
            {
                question: 'Можно ли попробовать бесплатно?',
                answer: 'Да. 微鲤AI предоставляет бесплатные пробные кредиты, чтобы вы могли протестировать инструмент без оплаты, как и другие наши ИИ‑инструменты для обработки изображений.',
            },
            {
                question: 'Какие форматы изображений поддерживаются?',
                answer: 'Поддерживаются популярные форматы, включая JPEG и PNG. Загрузите изображение и удалите фон мгновенно.',
            },
            {
                question: 'Как быстро работает бесплатная версия?',
                answer: 'Очень быстро — обычно требуется всего несколько секунд. Скорость может немного отличаться в зависимости от сети.',
            },
            {
                question: 'Насколько безопасны загруженные изображения?',
                answer: 'Безопасно. Мы строго соблюдаем конфиденциальность: данные шифруются и хранятся на защищённых серверах, другие пользователи не могут просматривать или получать доступ к вашим файлам.',
            },
            {
                question: 'Подходит ли инструмент для старых изображений?',
                answer: 'Да. Он работает с любыми изображениями независимо от возраста, размера или качества. Лучший результат получается, когда объект хорошо отделяется от фона.',
            },
        ],
        uploadTip:
            'Поддерживаются JPEG, PNG, WEBP и др. Максимум 15MB, разрешение до 4096×4096 пикселей.',
    },
    pt: {
        pageTitle: 'Remoção de fundo de imagem com IA',
        title: 'Remova o fundo da imagem instantaneamente',
        short_title:
            'Detecção precisa: separe o assunto do fundo com um clique',
        description:
            'Nosso removedor de fundo com IA elimina cenários e elementos indesejados com um clique, usando detecção precisa do assunto para um resultado limpo e profissional. Ideal para retratos e fotos de produtos de e-commerce, com suporte a processamento em lote para editar várias imagens rapidamente.',
        keywords:
            'removedor de fundo com IA, remover fundo de imagem, remoção de fundo, tirar fundo, ferramenta de remover fundo, recorte de fundo',
        feature_title1: 'Aumente o apelo de produtos no e-commerce',
        feature_desc1:
            'Remova fundos que distraem e crie fotos de produto limpas e profissionais que chamam atenção, aumentam a confiança e melhoram a conversão.',
        feature_title2: 'Crie retratos profissionais e refinados',
        feature_desc2:
            'Remova o fundo de uma foto e gere instantaneamente um retrato elegante, ideal para currículo, portfólio e contextos profissionais.',
        feature_title3: 'Crie conteúdo chamativo para redes sociais',
        feature_desc3:
            'Separe o assunto para simplificar a criação de posts e anúncios, combinando perfeitamente com fundos personalizados ou designs criativos para aumentar o engajamento.',
        feature_title4: 'Economize tempo em projetos de design',
        feature_desc4:
            'Remova fundos com facilidade para focar na criação, acelerar o fluxo de trabalho e entregar resultados de alta qualidade em colagens, pôsteres e materiais de marketing.',
        use_step1: 'Clique para enviar uma imagem',
        use_step2: 'Aguarde a ferramenta detectar e remover o fundo',
        use_step3: 'Baixe em segundos uma imagem de alta qualidade sem fundo',
        faq: [
            {
                question: 'O que é um removedor de fundo com IA?',
                answer: 'Um removedor de fundo com IA remove instantaneamente o fundo de fotos e outras imagens. Ele usa IA para diferenciar o assunto do fundo e remover o fundo sem danificar o assunto.',
            },
            {
                question: 'Por que usar o nosso removedor de fundo?',
                answer: 'O 微鲤AI é uma das ferramentas mais poderosas para remover fundo de imagens. Com IA avançada, ele separa com precisão o assunto do fundo e remove o fundo com detalhes finos, permitindo adicionar qualquer novo fundo ao assunto.',
            },
            {
                question: 'Qual é o melhor removedor de fundo com IA?',
                answer: 'O 微鲤AI é uma ótima escolha graças à sua tecnologia líder. Ele separa assunto e fundo com estabilidade em diferentes tamanhos e qualidades de imagem, entregando resultados rápidos e consistentes.',
            },
            {
                question: 'Como remover o fundo com IA?',
                answer: 'Basta acessar a página do removedor de fundo do 微鲤AI e enviar a imagem. A IA identificará automaticamente o fundo e o removerá em segundos.',
            },
            {
                question: 'Posso testar gratuitamente?',
                answer: 'Sim. O 微鲤AI oferece créditos de teste gratuitos, para você experimentar sem pagar, assim como em nossas outras ferramentas de imagem com IA.',
            },
            {
                question: 'Quais formatos de imagem são suportados?',
                answer: 'A ferramenta suporta formatos populares como JPEG e PNG. Envie sua imagem e remova o fundo instantaneamente.',
            },
            {
                question: 'Quão rápido é o removedor de fundo gratuito?',
                answer: 'É muito rápido e normalmente leva apenas alguns segundos. A velocidade pode variar um pouco dependendo da rede.',
            },
            {
                question: 'Minhas imagens enviadas são privadas e seguras?',
                answer: 'Sim. Levamos privacidade e segurança a sério: todos os dados são criptografados e armazenados em servidores seguros, e outros usuários não podem ver nem acessar seus arquivos.',
            },
            {
                question: 'Ele consegue lidar com imagens antigas?',
                answer: 'Sim. Ele funciona com qualquer imagem, independentemente de idade, tamanho ou qualidade. Para melhores resultados, é ideal que haja contraste claro entre o assunto e o fundo.',
            },
        ],
        uploadTip:
            'Suporta JPEG, PNG, WEBP e mais. Tamanho máx. 15MB. Resolução máx. 4096×4096 pixels.',
    },
    it: {
        pageTitle: 'Rimozione di sfondo immagine con IA',
        title: "Rimuovi lo sfondo dell'immagine in un attimo",
        short_title:
            'Rilevamento preciso, separa soggetto e sfondo con un clic',
        description:
            'Il nostro strumento IA rimuove scene e distrazioni con un clic grazie a un riconoscimento preciso del soggetto, per un risultato pulito e professionale. Perfetto per ritratti e foto prodotto e-commerce, con supporto all’elaborazione in batch per modificare rapidamente più immagini.',
        keywords:
            'rimozione sfondo IA, rimuovere sfondo immagine, rimozione sfondo, togliere sfondo, strumento rimozione sfondo, scontorno IA',
        feature_title1: "Aumenta l'appeal dei prodotti e-commerce",
        feature_desc1:
            'Rimuovi sfondi che distraggono e crea foto prodotto pulite e professionali che attirano l’attenzione, aumentano la fiducia e migliorano le conversioni.',
        feature_title2: 'Crea ritratti professionali e curati',
        feature_desc2:
            'Rimuovi lo sfondo da una foto e ottieni subito un ritratto elegante, ideale per CV, portfolio e contesti professionali.',
        feature_title3: 'Crea contenuti social che catturano',
        feature_desc3:
            'Isola il soggetto per semplificare la creazione di post e annunci, integrandolo perfettamente con sfondi personalizzati o design creativi per aumentare il coinvolgimento.',
        feature_title4: 'Risparmia tempo nei progetti di design',
        feature_desc4:
            'Rimuovi gli sfondi con facilità per concentrarti sulle idee, velocizzare i flussi di lavoro e ottenere risultati di alta qualità per collage, poster e materiali marketing.',
        use_step1: "Clicca per caricare un'immagine",
        use_step2: 'Attendi che lo strumento rilevi e rimuova lo sfondo',
        use_step3:
            'Scarica in pochi secondi un’immagine di alta qualità senza sfondo',
        faq: [
            {
                question: 'Che cos’è un rimuovi-sfondo con IA?',
                answer: 'Un rimuovi-sfondo con IA permette di eliminare istantaneamente lo sfondo da foto e altre immagini. L’IA distingue soggetto e sfondo, rimuovendo lo sfondo senza danneggiare il soggetto.',
            },
            {
                question: 'Perché usare il nostro rimuovi-sfondo?',
                answer: '微鲤AI è uno dei più potenti strumenti di rimozione dello sfondo. Grazie a un’IA avanzata, separa con precisione soggetto e sfondo e rimuove lo sfondo con dettagli accurati, così puoi aggiungere qualsiasi nuovo sfondo al soggetto.',
            },
            {
                question: 'Qual è il miglior rimuovi-sfondo con IA?',
                answer: '微鲤AI è un’ottima scelta grazie alla sua tecnologia leader. Gestisce in modo stabile la separazione tra soggetto e sfondo su immagini di diverse dimensioni e qualità, offrendo risultati rapidi e costanti.',
            },
            {
                question: 'Come rimuovo lo sfondo con IA?',
                answer: 'Apri la pagina di rimozione sfondo di 微鲤AI e carica l’immagine da modificare. L’IA rileverà automaticamente lo sfondo e lo rimuoverà in pochi secondi.',
            },
            {
                question: 'Posso provarlo gratuitamente?',
                answer: 'Sì. 微鲤AI offre crediti di prova gratuiti, così puoi testare lo strumento senza pagare, come per gli altri strumenti IA di fotoritocco.',
            },
            {
                question: 'Quali formati di immagine sono supportati?',
                answer: 'Sono supportati i formati più diffusi, tra cui JPEG e PNG. Carica l’immagine e rimuovi lo sfondo all’istante.',
            },
            {
                question: 'Quanto è veloce lo strumento gratuito?',
                answer: 'È molto veloce e di solito richiede solo pochi secondi. La velocità può variare leggermente in base alla rete.',
            },
            {
                question: 'Le immagini caricate sono private e sicure?',
                answer: 'Sì. Proteggiamo privacy e sicurezza: tutti i dati degli utenti sono cifrati e archiviati su server sicuri, e gli altri utenti non possono vedere né accedere ai tuoi file.',
            },
            {
                question: 'Può gestire immagini vecchie?',
                answer: 'Sì. Funziona con qualsiasi immagine, indipendentemente da età, dimensione o qualità. Per risultati migliori, è utile che ci sia una chiara distinzione tra soggetto e sfondo.',
            },
        ],
        uploadTip:
            'Supporta JPEG, PNG, WEBP e altro. Dimensione max 15MB. Risoluzione max 4096×4096 pixel.',
    },
    ar: {
        pageTitle: 'إزالة الخلفية من الصور بالذكاء الاصطناعي',
        title: 'أزل خلفية الصورة فورًا',
        short_title: 'تعرّف دقيق، افصل العنصر عن الخلفية بنقرة واحدة',
        description:
            'أداة إزالة الخلفية بالذكاء الاصطناعي لدينا تزيل المشاهد والعناصر غير المرغوبة بنقرة واحدة بفضل التعرّف الدقيق على العنصر الأساسي. مناسبة للصور الشخصية الاحترافية وصور منتجات التجارة الإلكترونية، وتدعم المعالجة الدُفعية لتعديل عدة صور بسرعة.',
        keywords:
            'إزالة خلفية بالذكاء الاصطناعي, إزالة خلفية الصورة, حذف الخلفية, قص الخلفية, أداة إزالة الخلفية, إزالة الخلفية للصور',
        feature_title1: 'زيد جاذبية صور المنتجات للتجارة الإلكترونية',
        feature_desc1:
            'احذف الخلفيات المشتتة لإنشاء صور منتجات نظيفة واحترافية تجذب الانتباه وتزيد الثقة وترفع معدلات التحويل.',
        feature_title2: 'أنشئ صورًا شخصية احترافية أنيقة',
        feature_desc2:
            'أزل الخلفية من الصورة واحصل فورًا على صورة شخصية أنيقة مناسبة للسيرة الذاتية والمعرض الشخصي والاستخدامات المهنية.',
        feature_title3: 'اصنع محتوى لافتًا لوسائل التواصل الاجتماعي',
        feature_desc3:
            'افصل العنصر الأساسي لتسهيل إنشاء المنشورات والإعلانات، وادمجه بسلاسة مع خلفيات مخصصة أو تصاميم إبداعية لزيادة التفاعل.',
        feature_title4: 'وفّر وقتك في مشاريع التصميم',
        feature_desc4:
            'أزل الخلفيات بسهولة للتركيز على الأفكار وتسريع سير العمل وتحقيق نتائج عالية الجودة للملصقات والكولاج ومواد التسويق.',
        use_step1: 'انقر لرفع صورة',
        use_step2: 'انتظر حتى تتعرّف الأداة على الخلفية وتزيلها',
        use_step3: 'نزّل خلال ثوانٍ صورة عالية الجودة بدون خلفية',
        faq: [
            {
                question: 'ما هي أداة إزالة الخلفية بالذكاء الاصطناعي؟',
                answer: 'أداة إزالة الخلفية بالذكاء الاصطناعي تتيح إزالة خلفية الصور وغيرها فورًا. تستخدم خوارزميات الذكاء الاصطناعي لتمييز الخلفية عن العنصر الأساسي وإزالة الخلفية دون إتلاف العنصر.',
            },
            {
                question: 'لماذا تستخدم أداة إزالة الخلفية الخاصة بنا؟',
                answer: '微鲤AI هي واحدة من أقوى أدوات إزالة خلفية الصور. تستخدم تقنيات ذكاء اصطناعي متقدمة لفصل العنصر عن الخلفية بدقة وإزالة الخلفية بتفاصيل دقيقة، بحيث يمكنك إضافة أي خلفية جديدة تريدها.',
            },
            {
                question: 'ما أفضل أداة إزالة خلفية بالذكاء الاصطناعي؟',
                answer: '微鲤AI خيار ممتاز بفضل تقنيته الرائدة. يتعامل بثبات مع صور مختلفة الأحجام والجودة ويفصل العنصر عن الخلفية بسرعة وبنتائج متسقة.',
            },
            {
                question: 'كيف أزيل الخلفية بالذكاء الاصطناعي؟',
                answer: 'ما عليك سوى فتح صفحة إزالة الخلفية في 微鲤AI ورفع الصورة التي تريد تعديلها. سيتعرّف الذكاء الاصطناعي على الخلفية ويزيلها خلال ثوانٍ.',
            },
            {
                question: 'هل يمكنني التجربة مجانًا؟',
                answer: 'نعم. يوفر 微鲤AI أرصدة تجربة مجانية لتتمكن من اختبار الأداة دون دفع، مثل أدوات تحرير الصور الأخرى لدينا.',
            },
            {
                question: 'ما صيغ الصور المدعومة؟',
                answer: 'تدعم الأداة الصيغ الشائعة مثل JPEG وPNG. ارفع صورتك وأزل الخلفية فورًا.',
            },
            {
                question: 'ما مدى سرعة الأداة المجانية؟',
                answer: 'سريعة جدًا وغالبًا ما تنتهي خلال ثوانٍ. قد تختلف السرعة قليلًا حسب ظروف الشبكة.',
            },
            {
                question: 'هل الصور المرفوعة خاصة وآمنة؟',
                answer: 'نعم. نحن نولي الخصوصية والأمان أهمية كبيرة. يتم تشفير بيانات المستخدم وتخزينها على خوادم آمنة، ولا يمكن للمستخدمين الآخرين عرض ملفاتك أو الوصول إليها.',
            },
            {
                question: 'هل يمكنها معالجة الصور القديمة؟',
                answer: 'نعم. تعمل مع أي صورة بغض النظر عن عمرها أو حجمها أو جودتها. ولأفضل النتائج، يُفضّل وجود تباين واضح بين العنصر الأساسي والخلفية.',
            },
        ],
        uploadTip:
            'يدعم JPEG وPNG وWEBP وغيرها. الحجم الأقصى 15MB، والدقة القصوى 4096×4096 بكسل.',
    },
    tw: {
        pageTitle: 'AI 圖片去背工具',
        title: '立即移除圖片背景',
        short_title:
            '精準辨識，一鍵分離主體/背景',
        description:
            'AI 去背一鍵清理場景雜訊，精準偵測主體，產生乾淨專業的成果。適合人像與電商商品照，並支援批次處理，可快速編輯多張圖片。',
        keywords:
            'AI 圖片去背, 移除圖片背景, 去背, 移除背景, 去背工具, 背景移除工具',
        feature_title1: '提升電商商品吸引力',
        feature_desc1:
            '移除干擾背景，打造乾淨專業的商品照，吸引目光、建立信任並提升轉換率。',
        feature_title2: '製作精緻專業人像',
        feature_desc2:
            '移除照片背景，立即生成適合履歷、作品集與專業場合的優雅人像。',
        feature_title3: '打造吸睛社群內容',
        feature_desc3:
            '分離主體，簡化貼文與廣告製作，與自訂背景或創意設計無縫融合，提升互動。',
        feature_title4: '節省設計專案時間',
        feature_desc4:
            '輕鬆去背聚焦創意，加快流程，為拼貼、海報與行銷素材提供高品質成果。',
        use_step1: '點擊上傳圖片',
        use_step2: '等待工具偵測並移除背景',
        use_step3:
            '數秒內下載透明背景的高畫質圖片',
        faq: [
            {
                question: '什麼是 AI 去背工具？',
                answer: 'AI 去背工具可即時移除照片與圖片背景，透過 AI 分辨主體與背景，在不損傷主體的情況下移除背景。',
            },
            {
                question: '為什麼要使用我們的去背工具？',
                answer: '微鲤AI 是最強大的圖片去背工具之一。先進 AI 能精準分離主體與背景，細節清楚，讓你想加任何新背景都可以。',
            },
            {
                question: '最好的 AI 去背工具是什麼？',
                answer: '微鲤AI 憑藉領先技術成為首選，能在不同尺寸與畫質下可靠分離主體與背景，快速且穩定。',
            },
            {
                question: '如何用 AI 移除背景？',
                answer: '打開 微鲤AI 去背頁面並上傳要編輯的圖片，AI 會自動偵測背景並在數秒內移除。',
            },
            {
                question: '可以免費試用嗎？',
                answer: '可以，微鲤AI 提供免費試用額度，讓你像使用其他 AI 圖片工具一樣先體驗。',
            },
            {
                question: '支援哪些圖片格式？',
                answer: '支援 JPEG、PNG 等常見格式，上傳即可立即去背。',
            },
            {
                question: '免費去背速度多快？',
                answer: '非常快，通常幾秒內完成。速度可能因網路狀況略有差異。',
            },
            {
                question: '上傳圖片安全嗎？',
                answer: '安全。我們重視隱私與安全，使用者資料會加密並儲存在安全伺服器上，其他人無法查看或存取。',
            },
            {
                question: '可以處理舊照片嗎？',
                answer: '可以，無論年代、尺寸或畫質都能處理。為了最佳效果，主體與背景要有明顯對比。',
            },
        ],
        uploadTip:
            '支援 JPEG、PNG、WEBP 等。最大 15MB，最高解析度 4096×4096 像素。',
    },
    pl: {
        pageTitle: 'Narzędzie AI do usuwania tła obrazów',
        title: 'Usuń tło obrazu natychmiast',
        short_title:
            'Precyzyjne wykrywanie, separacja obiektu i tła jednym kliknięciem',
        description:
            'Nasz AI remover tła usuwa scenę i zbędne elementy jednym kliknięciem dzięki precyzyjnemu wykrywaniu obiektu, zapewniając czyste, profesjonalne efekty. Idealne do portretów i zdjęć produktów e-commerce, obsługuje też przetwarzanie wsadowe do szybkiej edycji wielu obrazów.',
        keywords:
            'AI usuwanie tła, usuń tło obrazu, usuwanie tła, usuń tło, narzędzie do usuwania tła, narzędzie usuwania tła',
        feature_title1: 'Zwiększ atrakcyjność produktów e-commerce',
        feature_desc1:
            'Usuń rozpraszające tła, aby uzyskać czyste, profesjonalne zdjęcia produktów, które przyciągają uwagę, budują zaufanie i zwiększają konwersję.',
        feature_title2: 'Twórz dopracowane profesjonalne portrety',
        feature_desc2:
            'Usuń tło ze zdjęcia i natychmiast uzyskaj elegancki portret idealny do CV, portfolio i zastosowań zawodowych.',
        feature_title3: 'Twórz przyciągające treści w mediach społecznościowych',
        feature_desc3:
            'Wyodrębnij obiekt, aby uprościć tworzenie postów i reklam, a następnie łącz z niestandardowymi tłami lub kreatywnymi projektami dla większego zaangażowania.',
        feature_title4: 'Oszczędzaj czas w projektach graficznych',
        feature_desc4:
            'Łatwo usuwaj tła, skup się na pomyśle, przyspiesz pracę i dostarczaj wysokiej jakości efekty dla kolaży, plakatów i materiałów marketingowych.',
        use_step1: 'Kliknij, aby przesłać obraz',
        use_step2: 'Poczekaj, aż narzędzie wykryje i usunie tło',
        use_step3:
            'Pobierz w kilka sekund wysokiej jakości obraz z przezroczystym tłem',
        faq: [
            {
                question: 'Czym jest AI do usuwania tła?',
                answer: 'AI do usuwania tła natychmiast usuwa tło ze zdjęć i innych obrazów. Wykorzystuje AI do rozróżnienia obiektu i tła, usuwając tło bez uszkodzenia obiektu.',
            },
            {
                question: 'Dlaczego warto używać naszego narzędzia?',
                answer: '微鲤AI to jedno z najpotężniejszych narzędzi do usuwania tła. Zaawansowane AI precyzyjnie oddziela obiekty od tła i usuwa tło z dużą dbałością o detale — możesz dodać dowolne nowe tło.',
            },
            {
                question: 'Jakie jest najlepsze narzędzie AI do usuwania tła?',
                answer: '微鲤AI to topowy wybór dzięki wiodącej technologii. Niezawodnie separuje obiekty od tła w różnych rozmiarach i jakości obrazu, zapewniając szybkie i spójne rezultaty.',
            },
            {
                question: 'Jak usunąć tło za pomocą AI?',
                answer: 'Otwórz stronę narzędzia 微鲤AI i prześlij obraz do edycji. AI automatycznie wykryje tło i usunie je w kilka sekund.',
            },
            {
                question: 'Czy mogę wypróbować narzędzie za darmo?',
                answer: 'Tak. 微鲤AI oferuje darmowe kredyty próbne, dzięki którym możesz przetestować usuwanie tła bez opłat — tak jak w innych naszych narzędziach AI do obrazów.',
            },
            {
                question: 'Jakie formaty obrazów są obsługiwane?',
                answer: 'Narzędzie obsługuje popularne formaty, takie jak JPEG i PNG. Prześlij obraz i usuń tło natychmiast.',
            },
            {
                question: 'Jak szybkie jest darmowe usuwanie tła?',
                answer: 'Bardzo szybkie i zazwyczaj kończy się w kilka sekund. Szybkość może się nieznacznie różnić w zależności od sieci.',
            },
            {
                question: 'Czy moje przesłane obrazy są prywatne i bezpieczne?',
                answer: 'Tak. Traktujemy prywatność i bezpieczeństwo bardzo poważnie. Wszystkie dane użytkowników są szyfrowane i przechowywane na bezpiecznych serwerach, a inni użytkownicy nie mogą zobaczyć ani uzyskać dostępu do Twoich plików.',
            },
            {
                question: 'Czy narzędzie poradzi sobie ze starymi zdjęciami?',
                answer: 'Tak. Działa z każdym obrazem niezależnie od wieku, rozmiaru czy jakości. Dla najlepszych rezultatów upewnij się, że obiekt wyraźnie kontrastuje z tłem.',
            },
        ],
        uploadTip:
            'Obsługuje JPEG, PNG, WEBP i inne. Maks. rozmiar 15MB. Maks. rozdzielczość 4096×4096 px.',
    },
    th: {
        pageTitle: 'เครื่องมือลบพื้นหลังภาพด้วย AI',
        title: 'ลบพื้นหลังภาพได้ทันที',
        short_title:
            'ตรวจจับแม่นยำ แยกตัวแบบ/พื้นหลังได้ในคลิกเดียว',
        description:
            'เครื่องมือลบพื้นหลังด้วย AI ของเราลบฉากและสิ่งรบกวนได้ในคลิกเดียวด้วยการตรวจจับตัวแบบอย่างแม่นยำ ให้ผลลัพธ์สะอาดและดูมืออาชีพ เหมาะสำหรับภาพพอร์ตเทรตและภาพสินค้าของอีคอมเมิร์ซ พร้อมรองรับการประมวลผลแบบชุดเพื่อแก้ไขหลายภาพได้อย่างรวดเร็ว',
        keywords:
            'เครื่องมือลบพื้นหลังภาพด้วย AI, ลบพื้นหลังภาพ, การลบพื้นหลัง, ลบพื้นหลัง, เครื่องมือลบพื้นหลัง, เครื่องมือลบฉากหลัง',
        feature_title1: 'เพิ่มความน่าสนใจของสินค้าอีคอมเมิร์ซ',
        feature_desc1:
            'ลบพื้นหลังที่รบกวนเพื่อสร้างภาพสินค้าที่สะอาดและเป็นมืออาชีพ ดึงดูดสายตา สร้างความเชื่อมั่น และเพิ่มคอนเวอร์ชัน',
        feature_title2: 'สร้างพอร์ตเทรตมืออาชีพที่ดูดี',
        feature_desc2:
            'ลบพื้นหลังของภาพเพื่อได้พอร์ตเทรตที่ดูเรียบหรู เหมาะกับเรซูเม่ พอร์ตโฟลิโอ และการใช้งานทางการ',
        feature_title3: 'ทำคอนเทนต์โซเชียลให้สะดุดตา',
        feature_desc3:
            'แยกตัวแบบเพื่อทำโพสต์และโฆษณาได้ง่ายขึ้น ผสานกับพื้นหลังที่กำหนดเองหรือดีไซน์สร้างสรรค์เพื่อเพิ่มการมีส่วนร่วม',
        feature_title4: 'ประหยัดเวลาในงานดีไซน์',
        feature_desc4:
            'ลบพื้นหลังได้อย่างง่ายดาย โฟกัสที่ไอเดีย เร่งเวิร์กโฟลว์ และส่งมอบผลงานคุณภาพสูงสำหรับคอลลาจ โปสเตอร์ และสื่อการตลาด',
        use_step1: 'คลิกเพื่ออัปโหลดรูปภาพ',
        use_step2: 'รอให้เครื่องมือสแกนและลบพื้นหลัง',
        use_step3:
            'ดาวน์โหลดภาพคุณภาพสูงพื้นหลังโปร่งใสได้ในไม่กี่วินาที',
        faq: [
            {
                question: 'AI ลบพื้นหลังคืออะไร?',
                answer: 'เครื่องมือลบพื้นหลังด้วย AI จะลบพื้นหลังของรูปภาพได้ทันที โดยใช้ AI แยกตัวแบบออกจากพื้นหลังและลบพื้นหลังโดยไม่ทำลายตัวแบบ',
            },
            {
                question: 'ทำไมต้องใช้เครื่องมือลบพื้นหลังของเรา?',
                answer: '微鲤AI เป็นหนึ่งในเครื่องมือลบพื้นหลังที่ทรงพลังที่สุด ด้วย AI ขั้นสูงที่แยกตัวแบบจากพื้นหลังได้อย่างแม่นยำและเก็บรายละเอียดได้ดี คุณจึงเปลี่ยนพื้นหลังเป็นอะไรก็ได้',
            },
            {
                question: 'เครื่องมือลบพื้นหลัง AI ที่ดีที่สุดคืออะไร?',
                answer: '微鲤AI เป็นตัวเลือกอันดับต้น ๆ ด้วยเทคโนโลยีชั้นนำ แยกตัวแบบจากพื้นหลังได้อย่างเชื่อถือได้ในหลายขนาดและคุณภาพของภาพ ให้ผลลัพธ์รวดเร็วและสม่ำเสมอ',
            },
            {
                question: 'จะลบพื้นหลังด้วย AI ได้อย่างไร?',
                answer: 'เพียงเปิดหน้าเครื่องมือลบพื้นหลังของ 微鲤AI และอัปโหลดภาพที่ต้องการแก้ไข AI จะตรวจจับและลบพื้นหลังให้อัตโนมัติภายในไม่กี่วินาที',
            },
            {
                question: 'ลองใช้ได้ฟรีไหม?',
                answer: 'ได้ 微鲤AI มีเครดิตทดลองฟรีเพื่อให้คุณทดสอบเครื่องมือลบพื้นหลังโดยไม่ต้องจ่าย เหมือนเครื่องมือ AI รูปภาพอื่น ๆ ของเรา',
            },
            {
                question: 'รองรับไฟล์ภาพอะไรบ้าง?',
                answer: 'รองรับฟอร์แมตยอดนิยม เช่น JPEG และ PNG อัปโหลดแล้วลบพื้นหลังได้ทันที',
            },
            {
                question: 'เครื่องมือลบพื้นหลังฟรีเร็วแค่ไหน?',
                answer: 'เร็วมาก และมักเสร็จภายในไม่กี่วินาที ความเร็วอาจต่างกันเล็กน้อยตามสภาพเครือข่าย',
            },
            {
                question: 'รูปที่อัปโหลดปลอดภัยไหม?',
                answer: 'ปลอดภัย เราให้ความสำคัญกับความเป็นส่วนตัวและความปลอดภัย ข้อมูลผู้ใช้ถูกเข้ารหัสและเก็บบนเซิร์ฟเวอร์ที่ปลอดภัย ผู้ใช้อื่นไม่สามารถดูหรือเข้าถึงไฟล์ของคุณได้',
            },
            {
                question: 'รองรับรูปเก่าหรือไม่?',
                answer: 'รองรับ ใช้ได้กับทุกภาพไม่ว่าเก่า ขนาด หรือคุณภาพใด เพื่อผลลัพธ์ที่ดีที่สุดควรมีความต่างระหว่างตัวแบบและพื้นหลังอย่างชัดเจน',
            },
        ],
        uploadTip:
            'รองรับ JPEG, PNG, WEBP และอื่น ๆ ขนาดสูงสุด 15MB ความละเอียดสูงสุด 4096×4096 พิกเซล',
    },
    da: {
        pageTitle: 'AI-værktøj til fjernelse af billedbaggrund',
        title: 'Fjern baggrund fra billeder øjeblikkeligt',
        short_title:
            'Præcis registrering, ét-klik adskillelse af motiv/baggrund',
        description:
            'Vores AI-baggrundsfjerner rydder scenen og rod med ét klik via præcis motivgenkendelse for rene, professionelle resultater. Perfekt til portrætter og e-handelsproduktbilleder og understøtter batchbehandling for hurtig redigering af flere billeder.',
        keywords:
            'AI baggrundsfjerner, fjern baggrund fra billede, baggrundsfjernelse, fjern baggrund, baggrundsfjerner værktøj, værktøj til baggrundsfjernelse',
        feature_title1: 'Øg e-handelsprodukters attraktivitet',
        feature_desc1:
            'Fjern forstyrrende baggrunde for at skabe rene, professionelle produktbilleder, der fanger opmærksomhed, bygger tillid og øger konverteringer.',
        feature_title2: 'Skab polerede professionelle portrætter',
        feature_desc2:
            'Fjern baggrunden fra et foto og få straks et elegant portræt, der passer til CV, portefølje og professionelle sammenhænge.',
        feature_title3: 'Lav iøjnefaldende indhold til sociale medier',
        feature_desc3:
            'Isolér motivet for at gøre opslag og annoncer nemmere, og kombiner sømløst med egne baggrunde eller kreative designs for større engagement.',
        feature_title4: 'Spar tid på designprojekter',
        feature_desc4:
            'Fjern baggrunde uden besvær for at fokusere på idéer, øge tempoet og levere resultater af høj kvalitet til collager, plakater og marketingmaterialer.',
        use_step1: 'Klik for at uploade et billede',
        use_step2: 'Vent på at værktøjet registrerer og fjerner baggrunden',
        use_step3:
            'Download et billede i høj kvalitet med gennemsigtig baggrund på få sekunder',
        faq: [
            {
                question: 'Hvad er en AI-baggrundsfjerner?',
                answer: 'En AI-baggrundsfjerner fjerner straks baggrunden fra fotos og andre billeder. Den bruger AI til at skelne motiv fra baggrund og fjerner baggrunden uden at skade motivet.',
            },
            {
                question: 'Hvorfor bruge vores baggrundsfjerner?',
                answer: '微鲤AI er et af de mest kraftfulde værktøjer til baggrundsfjernelse. Med avanceret AI adskiller den præcist motiv og baggrund og fjerner baggrunden med fine detaljer — så du kan tilføje den baggrund, du ønsker.',
            },
            {
                question: 'Hvad er den bedste AI-baggrundsfjerner?',
                answer: '微鲤AI er et topvalg takket være den førende teknologi. Den adskiller pålideligt motiv og baggrund i forskellige størrelser og billedkvaliteter og giver hurtige, konsistente resultater.',
            },
            {
                question: 'Hvordan fjerner jeg baggrund med AI?',
                answer: 'Åbn 微鲤AI-siden for baggrundsfjerner og upload det billede, du vil redigere. AI registrerer automatisk baggrunden og fjerner den på få sekunder.',
            },
            {
                question: 'Kan jeg prøve gratis?',
                answer: 'Ja. 微鲤AI tilbyder gratis prøvekreditter, så du kan teste baggrundsfjerneren uden at betale — ligesom vores andre AI-billedværktøjer.',
            },
            {
                question: 'Hvilke billedformater understøttes?',
                answer: 'Værktøjet understøtter populære formater som JPEG og PNG. Upload dit billede og fjern baggrunden med det samme.',
            },
            {
                question: 'Hvor hurtigt er den gratis baggrundsfjerner?',
                answer: 'Den er meget hurtig og afsluttes typisk på få sekunder. Hastigheden kan variere lidt afhængigt af netværket.',
            },
            {
                question: 'Er mine uploadede billeder private og sikre?',
                answer: 'Ja. Vi tager privatliv og sikkerhed alvorligt. Alle brugerdata krypteres og lagres på sikre servere, og andre brugere kan ikke se eller få adgang til dine filer.',
            },
            {
                question: 'Kan den håndtere gamle billeder?',
                answer: 'Ja. Den fungerer med alle billeder uanset alder, størrelse eller kvalitet. For bedste resultat skal der være tydelig kontrast mellem motiv og baggrund.',
            },
        ],
        uploadTip:
            'Understøtter JPEG, PNG, WEBP m.m. Maks. størrelse 15MB. Maks. opløsning 4096×4096 pixels.',
    },
    no: {
        pageTitle: 'AI-verktøy for fjerning av bildebakgrunn',
        title: 'Fjern bildebakgrunn umiddelbart',
        short_title:
            'Presis deteksjon, ett-klikks separasjon av motiv/bakgrunn',
        description:
            'Vår AI-bakgrunnsfjerner rydder scener og rot med ett klikk og presis motivdeteksjon for rene, profesjonelle resultater. Perfekt for portretter og produktbilder i netthandel, og støtter batchbehandling for rask redigering av flere bilder.',
        keywords:
            'AI bakgrunnsfjerner, fjern bildebakgrunn, bakgrunnsfjerning, fjern bakgrunn, bakgrunnsfjerner verktøy, verktøy for bakgrunnsfjerning',
        feature_title1: 'Øk attraktiviteten til e-handelsprodukter',
        feature_desc1:
            'Fjern distraherende bakgrunner for å lage rene, profesjonelle produktbilder som fanger oppmerksomhet, bygger tillit og øker konvertering.',
        feature_title2: 'Lag polerte profesjonelle portretter',
        feature_desc2:
            'Fjern bakgrunnen fra et bilde og få umiddelbart et elegant portrett som passer til CV, portefølje og profesjonelle settinger.',
        feature_title3: 'Lag iøynefallende innhold til sosiale medier',
        feature_desc3:
            'Isoler motivet for å forenkle innlegg og annonser, og bland sømløst med egendefinerte bakgrunner eller kreative design for høyere engasjement.',
        feature_title4: 'Spar tid på designprosjekter',
        feature_desc4:
            'Fjern bakgrunner enkelt for å fokusere på ideer, øke tempoet og levere resultater av høy kvalitet for collager, plakater og markedsmateriell.',
        use_step1: 'Klikk for å laste opp et bilde',
        use_step2: 'Vent mens verktøyet oppdager og fjerner bakgrunnen',
        use_step3:
            'Last ned et bilde i høy kvalitet med transparent bakgrunn på få sekunder',
        faq: [
            {
                question: 'Hva er en AI-bakgrunnsfjerner?',
                answer: 'En AI-bakgrunnsfjerner fjerner umiddelbart bakgrunnen fra bilder og andre grafiske filer. Den bruker AI til å skille motiv fra bakgrunn, og fjerner bakgrunnen uten å skade motivet.',
            },
            {
                question: 'Hvorfor bruke vår bakgrunnsfjerner?',
                answer: '微鲤AI er et av de mest kraftfulle verktøyene for bakgrunnsfjerning. Med avansert AI skiller den presist motiv fra bakgrunn og fjerner bakgrunnen med fine detaljer — slik at du kan legge til hvilken som helst ny bakgrunn.',
            },
            {
                question: 'Hva er den beste AI-bakgrunnsfjerneren?',
                answer: '微鲤AI er et toppvalg takket være ledende teknologi. Den separerer motiv og bakgrunn pålitelig på tvers av ulike størrelser og bildekvaliteter, og leverer raske og konsistente resultater.',
            },
            {
                question: 'Hvordan fjerner jeg bakgrunn med AI?',
                answer: 'Åpne 微鲤AI-siden for bakgrunnsfjerner og last opp bildet du vil redigere. AI oppdager bakgrunnen automatisk og fjerner den på få sekunder.',
            },
            {
                question: 'Kan jeg prøve gratis?',
                answer: 'Ja. 微鲤AI tilbyr gratis prøvekreditter, så du kan teste bakgrunnsfjerneren uten å betale — akkurat som våre andre AI-bildeverktøy.',
            },
            {
                question: 'Hvilke bildeformater støttes?',
                answer: 'Verktøyet støtter populære formater som JPEG og PNG. Last opp bildet ditt og fjern bakgrunnen umiddelbart.',
            },
            {
                question: 'Hvor rask er den gratis bakgrunnsfjerneren?',
                answer: 'Den er svært rask og blir som regel ferdig på noen sekunder. Hastigheten kan variere litt avhengig av nettforhold.',
            },
            {
                question: 'Er bildene jeg laster opp private og sikre?',
                answer: 'Ja. Vi tar personvern og sikkerhet på alvor. Alle brukerdata krypteres og lagres på sikre servere, og andre brukere kan ikke se eller få tilgang til filene dine.',
            },
            {
                question: 'Kan den håndtere gamle bilder?',
                answer: 'Ja. Den fungerer med alle bilder uansett alder, størrelse eller kvalitet. For best resultat bør det være tydelig kontrast mellom motiv og bakgrunn.',
            },
        ],
        uploadTip:
            'Støtter JPEG, PNG, WEBP og mer. Maks størrelse 15MB. Maks oppløsning 4096×4096 piksler.',
    },
    nl: {
        pageTitle: 'AI-tool voor het verwijderen van afbeeldingsachtergrond',
        title: 'Verwijder de achtergrond van afbeeldingen direct',
        short_title:
            'Nauwkeurige detectie, onderwerp/achtergrond scheiden met één klik',
        description:
            'Onze AI-achtergrondverwijderaar ruimt scènes en rommel op met één klik dankzij nauwkeurige onderwerpherkenning voor schone, professionele resultaten. Perfect voor portretten en e-commerce productfoto\'s en ondersteunt batchverwerking voor snelle bewerking van meerdere afbeeldingen.',
        keywords:
            'AI-achtergrondverwijderaar, achtergrond verwijderen, achtergrondverwijdering, achtergrond wissen, tool voor achtergrond verwijderen, achtergrondverwijdertool',
        feature_title1: 'Verhoog de aantrekkingskracht van e-commerce producten',
        feature_desc1:
            'Verwijder afleidende achtergronden en maak schone, professionele productfoto\'s die aandacht trekken, vertrouwen opbouwen en conversie verhogen.',
        feature_title2: 'Maak verzorgde professionele portretten',
        feature_desc2:
            'Verwijder de achtergrond van een foto en maak direct een elegant portret, geschikt voor cv\'s, portfolio\'s en professionele settings.',
        feature_title3: 'Maak opvallende content voor social media',
        feature_desc3:
            'Isoleer het onderwerp om posts en advertenties te vereenvoudigen en meng naadloos met aangepaste achtergronden of creatieve ontwerpen voor meer betrokkenheid.',
        feature_title4: 'Bespaar tijd op designprojecten',
        feature_desc4:
            'Verwijder achtergronden moeiteloos om je te focussen op ideeën, workflows te versnellen en hoogwaardige resultaten te leveren voor collages, posters en marketingmateriaal.',
        use_step1: 'Klik om een afbeelding te uploaden',
        use_step2: 'Wacht tot het hulpmiddel de achtergrond detecteert en verwijdert',
        use_step3:
            'Download in enkele seconden een hoogwaardige afbeelding met transparante achtergrond',
        faq: [
            {
                question: 'Wat is een AI-achtergrondverwijderaar?',
                answer: 'Een AI-achtergrondverwijderaar verwijdert direct de achtergrond uit foto\'s en andere afbeeldingen. Het gebruikt AI om het onderwerp van de achtergrond te onderscheiden en verwijdert de achtergrond zonder het onderwerp te beschadigen.',
            },
            {
                question: 'Waarom onze achtergrondverwijderaar gebruiken?',
                answer: '微鲤AI is een van de krachtigste tools voor het verwijderen van achtergronden. Met geavanceerde AI scheidt het nauwkeurig onderwerpen van achtergronden en verwijdert het de achtergrond met fijne details — zodat je elke gewenste nieuwe achtergrond kunt toevoegen.',
            },
            {
                question: 'Wat is de beste AI-achtergrondverwijderaar?',
                answer: '微鲤AI is een topkeuze dankzij toonaangevende technologie. Het scheidt betrouwbaar onderwerp en achtergrond in verschillende formaten en beeldkwaliteiten en levert snelle, consistente resultaten.',
            },
            {
                question: 'Hoe verwijder ik een achtergrond met AI?',
                answer: 'Open de 微鲤AI-achtergrondverwijderaar en upload de afbeelding die je wilt bewerken. AI detecteert automatisch de achtergrond en verwijdert deze in enkele seconden.',
            },
            {
                question: 'Kan ik het gratis proberen?',
                answer: 'Ja. 微鲤AI biedt gratis proefcredits zodat je de achtergrondverwijderaar kunt testen zonder te betalen — net als bij onze andere AI-afbeeldingstools.',
            },
            {
                question: 'Welke afbeeldingsformaten worden ondersteund?',
                answer: 'De tool ondersteunt populaire formaten zoals JPEG en PNG. Upload je afbeelding en verwijder de achtergrond direct.',
            },
            {
                question: 'Hoe snel is de gratis achtergrondverwijderaar?',
                answer: 'Hij is zeer snel en klaar in slechts enkele seconden. De snelheid kan licht variëren afhankelijk van de netwerkcondities.',
            },
            {
                question: 'Zijn mijn uploads privé en veilig?',
                answer: 'Ja. We nemen privacy en veiligheid serieus. Alle gebruikersgegevens worden versleuteld en opgeslagen op beveiligde servers, en andere gebruikers kunnen je bestanden niet bekijken of openen.',
            },
            {
                question: 'Kan het oude foto\'s verwerken?',
                answer: 'Ja. Het werkt met elke afbeelding, ongeacht leeftijd, formaat of kwaliteit. Voor het beste resultaat moet er een duidelijk contrast zijn tussen onderwerp en achtergrond.',
            },
        ],
        uploadTip:
            'Ondersteunt JPEG, PNG, WEBP en meer. Max. grootte 15MB. Max. resolutie 4096×4096 pixels.',
    },
    id: {
        pageTitle: 'Penghapus latar belakang gambar AI',
        title: 'Hapus latar belakang gambar seketika',
        short_title:
            'Deteksi presisi, pemisahan objek/latar sekali klik',
        description:
            'Penghapus latar belakang AI kami membersihkan scene dan elemen yang mengganggu hanya dengan sekali klik berkat deteksi objek yang presisi untuk hasil yang rapi dan profesional. Cocok untuk potret dan foto produk e-commerce, serta mendukung pemrosesan batch untuk mengedit banyak gambar dengan cepat.',
        keywords:
            'penghapus latar belakang AI, hapus latar belakang gambar, penghapusan latar belakang, hapus latar, alat penghapus latar belakang, alat penghapusan latar belakang',
        feature_title1: 'Tingkatkan daya tarik produk e-commerce',
        feature_desc1:
            'Hapus latar yang mengganggu untuk membuat foto produk yang bersih dan profesional, menarik perhatian, membangun kepercayaan, dan meningkatkan konversi.',
        feature_title2: 'Buat potret profesional yang rapi',
        feature_desc2:
            'Hapus latar belakang foto untuk menghasilkan potret elegan yang cocok untuk CV, portofolio, dan kebutuhan profesional.',
        feature_title3: 'Buat konten media sosial yang menarik',
        feature_desc3:
            'Isolasi objek untuk memudahkan pembuatan posting dan iklan, lalu padukan dengan latar khusus atau desain kreatif untuk meningkatkan keterlibatan.',
        feature_title4: 'Hemat waktu untuk proyek desain',
        feature_desc4:
            'Hapus latar dengan mudah agar fokus pada ide, mempercepat alur kerja, dan menghasilkan materi berkualitas tinggi untuk kolase, poster, dan aset pemasaran.',
        use_step1: 'Klik untuk mengunggah gambar',
        use_step2: 'Tunggu alat mendeteksi dan menghapus latar',
        use_step3:
            'Unduh gambar berkualitas tinggi dengan latar transparan dalam hitungan detik',
        faq: [
            {
                question: 'Apa itu penghapus latar belakang AI?',
                answer: 'Penghapus latar belakang AI menghapus latar dari foto dan gambar lain secara instan. AI membedakan objek dari latar dan menghapus latar tanpa merusak objek.',
            },
            {
                question: 'Mengapa menggunakan penghapus latar kami?',
                answer: '微鲤AI adalah salah satu alat penghapusan latar paling kuat. Dengan AI canggih, alat ini memisahkan objek dan latar dengan presisi serta menghapus latar dengan detail halus — sehingga Anda bisa menambahkan latar apa pun yang diinginkan.',
            },
            {
                question: 'Apa penghapus latar AI terbaik?',
                answer: '微鲤AI adalah pilihan teratas berkat teknologinya yang terdepan. Alat ini memisahkan objek dari latar secara andal pada berbagai ukuran dan kualitas gambar, memberikan hasil cepat dan konsisten.',
            },
            {
                question: 'Bagaimana cara menghapus latar dengan AI?',
                answer: 'Buka halaman penghapus latar 微鲤AI dan unggah gambar yang ingin Anda edit. AI akan mendeteksi latar secara otomatis dan menghapusnya dalam hitungan detik.',
            },
            {
                question: 'Bisakah saya mencoba gratis?',
                answer: 'Ya. 微鲤AI menyediakan kredit uji coba gratis sehingga Anda bisa mencoba penghapus latar tanpa membayar — sama seperti alat AI gambar kami lainnya.',
            },
            {
                question: 'Format gambar apa yang didukung?',
                answer: 'Mendukung format populer seperti JPEG dan PNG. Unggah gambar Anda dan hapus latarnya seketika.',
            },
            {
                question: 'Seberapa cepat penghapus latar gratis?',
                answer: 'Sangat cepat dan biasanya selesai dalam beberapa detik. Kecepatan bisa sedikit bervariasi tergantung kondisi jaringan.',
            },
            {
                question: 'Apakah gambar yang saya unggah aman dan privat?',
                answer: 'Ya. Kami serius tentang privasi dan keamanan. Semua data pengguna dienkripsi dan disimpan di server aman, dan pengguna lain tidak dapat melihat atau mengakses file Anda.',
            },
            {
                question: 'Bisakah menangani gambar lama?',
                answer: 'Ya. Bisa digunakan pada gambar apa pun, terlepas dari usia, ukuran, atau kualitas. Untuk hasil terbaik, pastikan ada kontras yang jelas antara objek dan latar.',
            },
        ],
        uploadTip:
            'Mendukung JPEG, PNG, WEBP, dan lainnya. Ukuran maksimum 15MB. Resolusi maksimum 4096×4096 piksel.',
    },
    tr: {
        pageTitle: 'AI Görsel Arka Plan Kaldırıcı',
        title: 'Görsel arka planını anında kaldırın',
        short_title:
            'Hassas algılama, tek tıkla nesne/arka plan ayrımı',
        description:
            'AI arka plan kaldırıcıımız, hassas nesne algılama sayesinde tek tıkla sahne ve kalabalığı temizler, temiz ve profesyonel sonuçlar sağlar. Portreler ve e-ticaret ürün fotoğrafları için idealdir; çoklu görseli hızlı düzenlemek için toplu işlemeyi destekler.',
        keywords:
            'AI arka plan kaldırıcı, görsel arka planı kaldır, arka plan kaldırma, arka plan silme, arka plan kaldırma aracı, arka plan temizleme aracı',
        feature_title1: 'E-ticaret ürünlerinin cazibesini artırın',
        feature_desc1:
            'Dikkat dağıtan arka planları kaldırarak temiz, profesyonel ürün fotoğrafları oluşturun; dikkat çeker, güven oluşturur ve dönüşümleri artırır.',
        feature_title2: 'Şık profesyonel portreler oluşturun',
        feature_desc2:
            'Bir fotoğrafın arka planını kaldırarak özgeçmiş, portföy ve profesyonel kullanım için uygun zarif bir portreyi anında oluşturun.',
        feature_title3: 'Dikkat çekici sosyal medya içeriği üretin',
        feature_desc3:
            'Nesneyi izole ederek gönderi ve reklam üretimini kolaylaştırın; özel arka planlar veya yaratıcı tasarımlarla sorunsuzca birleştirip etkileşimi artırın.',
        feature_title4: 'Tasarım projelerinde zamandan tasarruf edin',
        feature_desc4:
            'Arka planları zahmetsizce kaldırın, fikre odaklanın, iş akışını hızlandırın ve kolaj, afiş ve pazarlama materyalleri için yüksek kaliteli sonuçlar sunun.',
        use_step1: 'Bir görsel yüklemek için tıklayın',
        use_step2: 'Araç arka planı algılayıp kaldırırken bekleyin',
        use_step3:
            'Şeffaf arka planlı yüksek kaliteli görseli saniyeler içinde indirin',
        faq: [
            {
                question: 'AI arka plan kaldırıcı nedir?',
                answer: 'AI arka plan kaldırıcı, fotoğrafların ve diğer görsellerin arka planını anında temizler. AI, nesneyi arka plandan ayırır ve arka planı nesneye zarar vermeden kaldırır.',
            },
            {
                question: 'Neden bizim arka plan kaldırıcıyı kullanmalıyım?',
                answer: '微鲤AI, mevcut en güçlü arka plan kaldırma araçlarından biridir. Gelişmiş AI, nesne ve arka planı hassas biçimde ayırır ve ince detaylarla arka planı kaldırır — böylece istediğiniz yeni arka planı ekleyebilirsiniz.',
            },
            {
                question: 'En iyi AI arka plan kaldırıcı hangisi?',
                answer: '微鲤AI, lider teknoloji sayesinde en iyi seçeneklerden biridir. Farklı boyut ve görüntü kalitelerinde nesne ile arka planı güvenilir şekilde ayırır, hızlı ve tutarlı sonuçlar sunar.',
            },
            {
                question: 'AI ile arka planı nasıl kaldırırım?',
                answer: '微鲤AI arka plan kaldırıcı sayfasını açın ve düzenlemek istediğiniz görseli yükleyin. AI arka planı otomatik algılar ve birkaç saniye içinde kaldırır.',
            },
            {
                question: 'Ücretsiz deneyebilir miyim?',
                answer: 'Evet. 微鲤AI, aracı ücretsiz denemeniz için deneme kredileri sunar — diğer AI görsel araçlarımız gibi.',
            },
            {
                question: 'Hangi görsel formatları destekleniyor?',
                answer: 'JPEG ve PNG gibi yaygın formatlar desteklenir. Görselinizi yükleyin ve arka planı anında kaldırın.',
            },
            {
                question: 'Ücretsiz arka plan kaldırma ne kadar hızlı?',
                answer: 'Çok hızlıdır ve genellikle birkaç saniyede tamamlanır. Hız, ağ koşullarına göre biraz değişebilir.',
            },
            {
                question: 'Yüklediğim görseller gizli ve güvenli mi?',
                answer: 'Evet. Gizlilik ve güvenliği ciddiye alıyoruz. Tüm kullanıcı verileri şifrelenir ve güvenli sunucularda saklanır; diğer kullanıcılar dosyalarınıza erişemez.',
            },
            {
                question: 'Eski fotoğrafları da işleyebilir mi?',
                answer: 'Evet. Yaş, boyut veya kalite fark etmeksizin tüm görsellerde çalışır. En iyi sonuç için nesne ile arka plan arasında net bir kontrast olmasına dikkat edin.',
            },
        ],
        uploadTip:
            'JPEG, PNG, WEBP ve daha fazlasını destekler. Maksimum boyut 15MB. Maksimum çözünürlük 4096×4096 piksel.',
    },
}
